import { render, staticRenderFns } from "./SparesReview.vue?vue&type=template&id=62ef97ad&scoped=true"
import script from "./SparesReview.vue?vue&type=script&lang=js"
export * from "./SparesReview.vue?vue&type=script&lang=js"
import style0 from "./SparesReview.vue?vue&type=style&index=0&id=62ef97ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef97ad",
  null
  
)

export default component.exports